import { forwardRef } from "react";
import PropTypes from "prop-types";
import PageTitle from "./PageTitle";

const Page = forwardRef(({ children, title = "", ...rest }, ref) => {
  return (
    <div ref={ref} {...rest}>
      <PageTitle title={title} />
      {children}
    </div>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

export default Page;
